import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHeartGames = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 65 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#F52E54"
        fillRule="evenodd"
        d="m7.57 34.167 14.115 10.415-1.875 2.541L5.594 36.634a2 2 0 0 1-.178-.154C.95 32.016 2.084 25.571 5.652 22.03c1.82-1.808 4.344-2.956 7.202-2.75 2.45.178 4.973 1.34 7.375 3.632 2.288-2.184 4.684-3.34 7.028-3.594 2.757-.299 5.23.674 7.08 2.308q.037.032.072.067l2.302 2.3-2.233 2.234-2.265-2.264c-1.261-1.098-2.86-1.696-4.616-1.505-1.777.193-3.926 1.218-6.184 3.778a1.58 1.58 0 0 1-2.368 0c-2.352-2.667-4.59-3.673-6.42-3.805s-3.488.588-4.748 1.84c-2.569 2.55-3.197 6.919-.308 9.897"
        clipRule="evenodd"
      />
      <path
        fill="#F52E54"
        d="M34.083 11.594 28.48 6.52c-3.046-3.046 1.43-8.893 5.603-4.162 4.172-4.73 8.628 1.137 5.603 4.162z"
      />
      <path
        fill="#0C222F"
        fillRule="evenodd"
        d="m22.12 53.274.45.763a18.94 18.94 0 0 0 11.663 8.774 18.94 18.94 0 0 0 12.72-1.136 1.2 1.2 0 0 0 .462-.158l10.303-6.081a5.043 5.043 0 0 0 1.78-6.907l-.755-1.28a5 5 0 0 0-1.998-1.902 5.046 5.046 0 0 0 1.405-6.658l-.75-1.27a5 5 0 0 0-2-1.894 4.97 4.97 0 0 0 1.95-2.836 5 5 0 0 0-.537-3.82l-.755-1.28a4.95 4.95 0 0 0-1.987-1.883l5.583-3.295a5.74 5.74 0 0 0 2.66-3.535 5.74 5.74 0 0 0-.62-4.38 5.74 5.74 0 0 0-3.535-2.66 5.74 5.74 0 0 0-4.38.62l-1.657.977c-.684-.838-1.428-1.462-2.239-1.859a4.8 4.8 0 0 0-2.954-.43c-1.893.31-3.632 1.641-5.112 3.149-1.512 1.538-2.921 3.438-4.131 5.166-.428.61-.825 1.19-1.193 1.729-.695 1.016-1.288 1.882-1.788 2.517l-5.835 3.443c-9.054 5.344-12.073 17.06-6.73 26.114zm17.526-32.485 5.15-3.04 2.11-1.238 3.144-1.855c-.43-.472-.836-.772-1.209-.955a2.45 2.45 0 0 0-1.527-.22c-1.119.184-2.41 1.048-3.808 2.471-1.359 1.384-2.67 3.138-3.86 4.837m15.346-6.256a3.376 3.376 0 0 1 4.612 1.19 3.35 3.35 0 0 1 .359 2.555 3.33 3.33 0 0 1-1.548 2.057L39.03 31.776a1.199 1.199 0 0 0 .315 2.2c.3.078.628.044.916-.125l10.114-5.97a2.634 2.634 0 0 1 3.604.929l.755 1.28a2.61 2.61 0 0 1-.927 3.595L43.7 39.648a1.2 1.2 0 0 0 .316 2.2c.3.078.627.044.915-.125l6.803-4.015a2.634 2.634 0 0 1 3.603.929l.749 1.269a2.634 2.634 0 0 1-.929 3.603l-6.802 4.015a1.2 1.2 0 0 0 .315 2.2c.3.078.628.044.916-.125l3.5-2.066c1.21-.714 2.89-.282 3.603.928l.755 1.28a2.634 2.634 0 0 1-.928 3.603l-9.024 5.326a16.55 16.55 0 0 1-12.619 1.784 16.55 16.55 0 0 1-10.183-7.661l-.451-.764c-4.67-7.913-2.035-18.14 5.879-22.81l24.92-14.707z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHeartGames;
